
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"80","height":"81","fill":"none"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M71.165 26.494H8.55c-3.144 0-5.693 2.537-5.693 5.667v39.666c0 3.13 2.549 5.667 5.693 5.667h62.615c3.144 0 5.692-2.537 5.692-5.666V32.16c0-3.13-2.548-5.667-5.692-5.667zM2.857 49.16h74","stroke":"currentColor","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M39.858 43.494v11.334","stroke":"#fff","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M56.934 26.494c0-4.508-1.799-8.832-5.001-12.02a17.116 17.116 0 00-12.075-4.98v0c-4.53 0-8.873 1.791-12.076 4.98a16.962 16.962 0 00-5.001 12.02","stroke":"currentColor","stroke-width":"4","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    